import './MetodiPagamento.css';
import '../LoghiPagamento.css';
import { Config } from '../../Config';
import API from '../../library/ApiManager'
import Loader from "react-loader-spinner";
import Fnc from '../../library/Functions';
import React, { useState, useEffect } from 'react';
import DialogMsg from '../DialogMsg';
import {
	useNavigate
} from "react-router-dom";


function MetodiPagamento(props) {

	const [loadingZuora, setLoadingZuora] = useState(false);
	const [loadingPayOperation, setLoadingPayOperation] = useState(false);
	const [dlgConf, setDlgConf] = useState(null);
	const [showZuoraForm, setShowZuoraForm] = useState(false);
	const [btnZuoraEnabled, setBtnZuoraEnabled] = useState(false);
	const [payMethods, setPayMethods] = useState(null);
	const [showOldPayMethods, setShowOldPayMethods] = useState(false);
	const [choosenOldPayMethod, setChoosenOldPayMethod] = useState(null);
	const [paypalInitialized, setPaypalInitialized] = useState(false);


	const navigate = useNavigate();

	useEffect(() => {
		// Similar to componentDidMount and componentDidUpdate:

		if (props.invoiceData === null) {
			setDlgConf(new Fnc.DlgConf("Il pagamento non può essere portato a termine", "Per poter comprare è necessario inserire i dati di fatturazione", false, "Chiudi", "", () => {
				let fatturazioneStep = Config.stepList.find(function (el) {
					return el.idx === 10;
				})
				navigate(fatturazioneStep.path);
			}))
			Fnc.gaException("[MetodiPagamento.js@useEffect] Dati fatturazione vuoti, probabile refresh", null, false, Fnc.ExcCatgory.PAY_METHOD.val);
		}

		if (window.Z) {
			window.Z.setEventHandler("onloadCallback", function () {
				//Callback chimata da Zuora quando la form è caricata
				Fnc.log("ZUORA FORM LOADED:", null, Fnc.LogLvl.DEBUG);

				setLoadingZuora(false);
				setShowZuoraForm(true);
				setBtnZuoraEnabled(true);
			});
		}

		window['submitFail'] = (msg, objErr) => {
			// ZUORA CALLBACK KO: callback dopo invio dati da Zuora alla url di callback /services_v1/checkout in caso di problemi. 
			Fnc.log("ZUORA CALLBACK KO", objErr, Fnc.LogLvl.DEBUG);
			setShowZuoraForm(false);
			setBtnZuoraEnabled(false);
			setLoadingPayOperation(false);
			let errMsg = null;
			if (objErr && objErr != null) {
				var msgObj = JSON.parse(objErr);
				errMsg = msgObj.message && msgObj.message != null ? msgObj.message : "EMPTY";
			} else {
				errMsg = msg && msg != null ? msg : "EMPTY";
			}
			setDlgConf(new Fnc.DlgConf("Il pagamento non è riuscito", "Ci sono problemi nella gestione della richiesta. [" + errMsg + "]", true, "Chiudi", ""))
			Fnc.gaException("[MetodiPagamento.js@useEffect] Configurazione metodo di pagamento rifiutato da Zuora", errMsg, true, Fnc.ExcCatgory.ZUORA.val);
		};

		window['submitSucceed'] = (obj) => {
			// ZUORA CALLBACK OK: callback dopo invio dati da Zuora alla url di callback /services_v1/checkout in caso di successo.
			Fnc.log("ZUORA CALLBACK OK", obj, Fnc.LogLvl.DEBUG);
			props.handleNext(new Fnc.Ret(Fnc.EnmPay.OK, obj));
		};

		loadZuoraForm(true);

		//gestione salvataggio telefono in carrello
		let invData = props.invoiceData;   
		if (invData && invData.phone && invData.phone !== "") { //se utente lo ha inserito
			try {
				API.sendBskRmrk(invData.phone,invData.nam,invData.snam, invData.rs, invData.iva, invData.fProm, (data) => {
				//nessuna azione deve essere silente.
			}); }
			catch(e) {
				Fnc.log("Errore silente invio telefono in carrello", e, Fnc.LogLvl.DEBUG);
			}
		}


	}, [props.user]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

	function loadZuoraForm(payMethodEnabled) {

		API.billingPreview((data) => {
			//chiamata solo per fissare la data e poi poter effettuare il controllo sull'invio dell'ordine lato server.

			if (props.user && props.user.response.code === 'OK') {
				//ho un utente loggato

				if (payMethodEnabled === true) {
					setPayMethods(null);
					API.getPaymentMethods((data) => {
						//recupero gli eventuali metodi di pagamento associati a questo utente

						if (data && data.response && data.response.code === 'OK') {
							//la chiamata ai metodi di pagamento è andata a buon fine, posso fare un check

							let payMethodId = (data.records && data.records.length > 0) ? data.records[0].Id : null;
							if (payMethodId !== null) {
								setBtnZuoraEnabled(true);
								setChoosenOldPayMethod(payMethodId);
								setShowOldPayMethods(true);
							} else {
								setBtnZuoraEnabled(false);
								setShowOldPayMethods(false);
							}

							setPayMethods(data.records);
							setLoadingZuora(false);

						} else {
							setShowOldPayMethods(false);
							manageNewPayMethod()
						}

					});
				} else {
					setShowOldPayMethods(false);
					manageNewPayMethod()
				}

			} else {
				setShowOldPayMethods(false);
				manageNewPayMethod()
			}

		});

	}

	function manageNewPayMethod() {

		let pageId = Fnc.currEnv().zuoraParam.id;

		API.zuoraIfrSignature(pageId, (data) => {
			Fnc.log("ZUORA IFR SIGNATURE:", data, Fnc.LogLvl.DEBUG);


			var p = Fnc.currEnv().zuoraParam;
			p['field_passthrough1'] = encodeURIComponent(Fnc.jsonSerialize(props.invoiceData));
			p['signature'] = data['data']['signature'];
			p['token'] = data['data']['token'];
			p['key'] = data['data']['key'];

			window.Z.renderWithErrorHandler(p, zuoraPopParam(), (response) => {
				//OK RENDER FORM 
				Fnc.log("ZUORA OK RENDER:", response, Fnc.LogLvl.DEBUG);
				//non si capisce perché non viene mai richiamata. 

			}, (key, code, message) => {
				//KO RENDER FORM : errore su validazione dati della form da parte di Zuora
				Fnc.log("ZUORA KO RENDER:", key, Fnc.LogLvl.DEBUG);

				var em = message;

				switch (key) {
					case 'creditCardNumber':
						if (code === '001') em = 'Numero di carta di credito, obbligatorio';
						else if (code === '002') em = 'Il numero di carta di credito non è esatto';
						break;
					case 'cardSecurityCode': em = 'Il codice di sicurezza non è esatto'; break;
					case 'creditCardExpirationYear': em = "L'anno di scandenza non è esatto"; break;
					case 'creditCardExpirationMonth': em = 'La data di scadenza non è esatta'; break;
					case 'creditCardType': em = 'Il tipo di carta non è esatto'; break;
					case 'error': em = 'La validazione è fallita , ' + message; break;
				}

				window.Z.sendErrorMessageToHpm(key, em);
				setBtnZuoraEnabled(true);
				Fnc.gaException("[MetodiPagamento.js@manageNewPayMethod] Errore validazione form di Zuora", em, false, Fnc.ExcCatgory.ZUORA.val);

			}, null, null, (boh) => {
				//removeModalLayer
				Fnc.log("ZUORA RMV MODAL:", boh, Fnc.LogLvl.DEBUG);


			});

		});
	}

	function zuoraPopParam() {
		return {
			'creditCardCountry': 'ITA'
		};
	}

	function sendDataToZuora() {
		setBtnZuoraEnabled(false);
		setLoadingPayOperation(true);
		window.Z.submit();
	}

	function onMethodChanged(e) {
		let val = e.currentTarget.value;
		if (val === 'zuora') {
			sessionStorage.setItem("payMethodType", "Carta di credito");
			if (props.validBasket) {
				setShowZuoraForm(false);
				setBtnZuoraEnabled(false);
				setLoadingZuora(true);
				loadZuoraForm(false);
			}
		} else {
			sessionStorage.setItem("payMethodType", "Paypal");
			//paypal
			setShowZuoraForm(false);
			setBtnZuoraEnabled(false);
			if (!paypalInitialized) {
				startPaypalPayment();
				setPaypalInitialized(true);
			}
		}
	}

	function performCheckoutDirect(isPaypal) {
		setLoadingZuora(true);
		if (choosenOldPayMethod != null && choosenOldPayMethod.length > 0) {
			let invData = props.invoiceData;
			if (isPaypal) {
				invData.gtw = 'pp';
			}
			let fpt = Fnc.jsonSerialize(invData);
			API.checkoutDirect(fpt, choosenOldPayMethod, (data) => {

				if (data && data.response && data.response.code === 'OK') {
					setLoadingZuora(false);
					Fnc.log("CHECKOUT DIRECT OK", data, Fnc.LogLvl.DEBUG);
					props.handleNext(new Fnc.Ret(Fnc.EnmPay.OKDIRECT, data));
				} else {
					Fnc.log("Checkout direct KO: ", data, Fnc.LogLvl.DEBUG);
					props.handleNext(new Fnc.Ret(Fnc.EnmPay.KO, data));
					Fnc.gaException("[MetodiPagamento.js@performCheckoutDirect] Checkout direct KO metodo di pagamento di default", JSON.stringify(data), true, Fnc.ExcCatgory.PAY_METHOD.val);
				}

			});
		} else {
			Fnc.log("CHECKOUT DIRECT NO PAY METHOD SELECTED", null, Fnc.LogLvl.DEBUG);
			setLoadingZuora(false);
		}

	}

	function switchToZuoraIf() {
		if (props.validBasket) {
			setLoadingZuora(true);
			loadZuoraForm(false);
		}
	}

	function startPaypalPayment() {

		let env = Fnc.currEnv().paypalParam;

		window.paypal.checkout.setup("GN6BKME23PA3E", {
			'locale': 'it_IT',
			'environment': env.environment,
			//'container': ['pp-form'],
			'buttons': [{
				'container': 'pp-form',
				'shape': 'pill',
				'color': 'gold',
				'size': 'medium',
				'type': 'checkout',
				'label': 'pay'
			}],
			'click': function (e) {
				e.preventDefault();

				API.billingPreview((data) => {
					//chiamata solo per fissare la data e poi poter effettuare il controllo sull'invio dell'ordine lato server.

					API.getPaypalToken((data) => {

						if (data && data.response && data.response.code === 'OK') {
							Fnc.log("GET PAYPAL TOKEN", data, Fnc.LogLvl.DEBUG);
							var url = window.paypal.checkout.urlPrefix + data['token'];
							Fnc.log("PAYPAL url", url, Fnc.LogLvl.DEBUG);
							window.paypal.checkout.startFlow(url);
						} else {
							Fnc.log("GET TOKEN FOR PAYPAL ERROR", data, Fnc.LogLvl.DEBUG);
							Fnc.gaException("[MetodiPagamento.js@startPaypalPayment] Impossibile recuperare il token paypal dalle api", JSON.stringify(data), true, Fnc.ExcCatgory.PAYPAL.val);
						}

					});

				});

			}
		});

	}

	return (
		<>
			<div className="iol-checkout-left-part col-xl-7">
				<p className="heading-3">Seleziona metodo di pagamento</p>
				{showOldPayMethods === false ?
					<>
						<div className="iol-checkout-left">
							<div className="iol-payment-radio">
								<label className="iol-radio-section">
									<input className="iol-radio" type="radio" name="payMethod" value="zuora" onChange={onMethodChanged}></input>
									<span className="iol-payment-text semibold">Paga con carta di credito/debito</span>
									<div className="iol-hidden">
										<Loader visible={loadingZuora} className="loadingSpinnerZuora" type="TailSpin" color={Fnc.LoadingInp.COLOR} height="80px" width="80px" timeout={Fnc.LoadingInp.TIMEOUT} />
										<div id="zuora_payment" className={`${showZuoraForm ? "" : "hideDiv"} zuoraForm`}></div>
										<button className="fucsia-button semibold btnConfirmPay" type="submit" disabled={!btnZuoraEnabled || !props.validBasket} onClick={() => { sendDataToZuora() }}>Conferma
											<Loader visible={loadingPayOperation} className="loadingSpinnerPayOp" type="Rings" color="#de1e63" height="32px" width="32px" timeout={Fnc.LoadingInp.TIMEOUT} />
											{/*<div id="loadReg" className={`loadingSet lds-ring ${loadingPayOperation ? "showLoading" : ""}`}>
												<div></div>
												<div></div>
												<div></div>
												<div></div>
											</div>*/}
										</button>
									</div>
								</label>
							</div>
						</div>
						<div className="iol-checkout-left">
							<div className="iol-payment-radio">
								<label className="iol-radio-section">
									<input className="iol-radio" type="radio" name="payMethod" value="paypal" onChange={onMethodChanged}></input>
									<span className="iol-payment-text semibold">Paga con PayPal</span>
									<div className="iol-paypal iol-hidden">
										<div className="iol-paypal-text semibold">Completa la procedura di pagamento su PayPal. Premi il pulsante qui sotto per aprire la finestra di pagamento e segui le istruzioni. </div>
										<form id="pp-form" method="post"></form>
										{/*<button className="blue-button semibold" type="submit" onClick={startPaypalPayment}>Paga con PayPal</button>*/}
									</div>
								</label>
								<div className="iol-logos-wrapper">
									<a className="iol-logo" href="#"><div className="logoPayapal" alt="logo Paypal" /></a>
								</div>
							</div>
						</div>
					</>
					:
					<div className="iol-checkout-left-part col-xl-7">
						<div className="iol-select-activity-wrapper row">
							{payMethods !== null && payMethods.map((pay, index) => (
								pay.CreditCardMaskNumber && pay.CreditCardMaskNumber !== null ?
									<div className="iol-activity payMethod" key={pay.Id}>
										<div className="iol-activity-text" key={`2${pay.Id}`}>
											<label className="iol-activity-title semibold" htmlFor="pay1" key={`3${pay.Id}`}>{pay.CreditCardType + " " + pay.CreditCardMaskNumber}</label>
											<label className="iol-activity-address caption" htmlFor="pay1" key={`4${pay.Id}`}>{pay.CreditCardHolderName}</label>
											<label className="iol-activity-address caption" htmlFor="pay1" key={`5${pay.Id}`}>Scadenza {pay.CreditCardExpirationMonth}/{pay.CreditCardExpirationYear}</label>
										</div>
										<button className="fucsia-button semibold" type="submit" disabled={!btnZuoraEnabled || !props.validBasket} onClick={() => { performCheckoutDirect(false) }}>Conferma</button>
									</div>
									:
									<div className="iol-activity payMethod" key={pay.Id}>
										<div className="iol-activity-text" key={`2${pay.Id}`}>
											<label className="iol-activity-title semibold" htmlFor="pay1" key={`3${pay.Id}`}>Paypal</label>
											<label className="iol-activity-address caption" htmlFor="pay1" key={`4${pay.Id}`}>{pay.PaypalEmail}</label>
										</div>
										<button className="fucsia-button semibold" type="submit" disabled={!btnZuoraEnabled || !props.validBasket} onClick={() => { performCheckoutDirect(true) }}>Conferma</button>
									</div>

							))}
							<button className="fucsia-button semibold" type="submit" onClick={() => { switchToZuoraIf() }}>Aggiungi nuovo metodo</button>
						</div>

					</div>
				}
			</div>


			{dlgConf != null &&
				<DialogMsg conf={dlgConf} ></DialogMsg>
			}

		</>

	);
}

export default MetodiPagamento;
